import { render, staticRenderFns } from "./ChargesSettingsComponent.vue?vue&type=template&id=5bfde0be"
import script from "./ChargesSettingsComponent.vue?vue&type=script&lang=js"
export * from "./ChargesSettingsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports